import { render, staticRenderFns } from "./center-text-doughnut-card.vue?vue&type=template&id=6dbd2a58&"
import script from "./center-text-doughnut-card.vue?vue&type=script&lang=js&"
export * from "./center-text-doughnut-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "center-text-doughnut-card.vue"
export default component.exports